import { render, staticRenderFns } from "./CallActionItem.vue?vue&type=template&id=0b4429c7&scoped=true&"
import script from "./CallActionItem.vue?vue&type=script&lang=js&"
export * from "./CallActionItem.vue?vue&type=script&lang=js&"
import style0 from "./CallActionItem.vue?vue&type=style&index=0&id=0b4429c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4429c7",
  null
  
)

export default component.exports